import { Stack } from "@mui/material"
import { Button, DialogHandler, Typography } from "@cakemail-org/ui-components-v2"
import { t } from "i18next"
import { type MouseEvent } from "react"
import { TUnsaveChangesDialogContent, TUnsaveChangesDialogResult } from "./types"


function UnsaveChangesDialogContent({ resolve, reject }: TUnsaveChangesDialogContent) {

    return <Stack direction="column" gap={8} marginTop={8}>
        <Typography variant="body1">{t("unsaved-changes-desc")}</Typography>

        <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center" className="dialogBtns">
            <Typography sx={{ marginRight: "auto!important", display: "inline-block", cursor: "pointer" }} variant="body2" onClick={() => {
                DialogHandler.hide()
                resolve({ e: {} as MouseEvent<HTMLButtonElement>, action: "cancel", btnRef: undefined })
            }}>{t("general-cancel")}</Typography>
            <Button
                variant="outlined"
                color="body1"
                onClick={(e, btnRef) => {
                    DialogHandler.hide()
                    resolve({ e, action: "close", btnRef })
                }}
            >
                {t("general-close")}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                animated
                onClick={(e, btnRef) => {
                    resolve({ e, action: "save", btnRef })
                }}
            >
                {t("general-save-continue")}
            </Button>

        </Stack>
    </Stack>
}


export async function showUnsaveChangesDialog(): Promise<TUnsaveChangesDialogResult> {
    return new Promise((resolve, reject) => {
        DialogHandler.show({
            managedByContent: true,
            title: t("general-unsaved-changes"),
            content: (
                <UnsaveChangesDialogContent resolve={resolve} reject={reject} />
            ),
        })
    })
}